import Card from "components/card";
import React, { useEffect } from "react";
import { Table, Input } from 'antd';
import { connect } from "react-redux";
import { NumberFormatter } from "../../../../utils/index";

const InvoiceItemTable = ({invoiceData}) => {
	
  const columns = [
    {
        title: `Description`,
        dataIndex: 'iit_description',
        key: 'iit_description',
        width: '64%', 
    },
    {
        title: <div className="text-right">Quantity</div>,
        dataIndex: 'iit_quantity',
        key: 'iit_quantity',
        width: '8%',  
		render: (iit_quantity) => <div className="text-right">{iit_quantity}</div>
    },
    {
        title: <div className="text-right">Price</div>,
        dataIndex: 'iit_price',
        key: 'iit_price',
        width: '10%',
       	render: (iit_price) => <div className="text-right">{NumberFormatter(iit_price)}</div>
    },    
	{
        title: <div className="text-right">Tax</div>,
        dataIndex: 'iit_tax',
        key: 'iit_tax',
        width: '8%',
		render: (iit_tax) => <div className="text-right">{iit_tax}%</div>
    },
    {
        title: <div className="text-right">Amount</div>,
        dataIndex: 'iit_amount',
        key: 'iit_amount',
        width: '15%',
        render: (iit_amount) => <div className="text-right">{NumberFormatter(iit_amount)}</div>
    }
    ];
	
  	return (
    	<Card extra={"w-full h-full p-4"}>
      		<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
      			<Table
        			dataSource={invoiceData?.invoice_items} 
		        	columns={columns} 
		          	rowKey={(record) => record.iit_id}
					pagination={false}       	
        		/>

				<div className="w-full flex justify-between p-4 gap-4 bg-white">
					<div>
						
					</div>
					<div className="item-right">
						<div className="grid grid-cols-3 gap-4">
							<div className="col-span-2">
								SubTotal
								<div className="text-[12px]">Includes GST of </div>
							</div>
							<div className="text-right">{invoiceData?.inv_subtotal}</div>
							<div className="col-span-2">Total</div>
							<div className="text-right">{invoiceData?.inv_subtotal}</div>
							<div className="col-span-2">Amount due</div>
							<div className="font-bold text-[18px] text-right">{invoiceData?.inv_amount_due}</div>
						</div>
						
					</div>
				</div>
      		</div>
    	</Card>
  	);
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
	
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceItemTable);